import React from 'react';
import { FileText } from 'lucide-react';
import ComingSoon from '../components/ComingSoon';

const DrawingEstimate = () => {
  return (
    <ComingSoon
      featureName="Drawing-based Estimate"
      description="Upload your construction drawings and architectural plans to get precise, detailed cost estimates. Our AI will analyze your blueprints and provide comprehensive cost breakdowns for every aspect of your project."
      icon={FileText}
    />
  );
};

export default DrawingEstimate;
